var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralRoom = function SvgDAhuGeneralRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 147.97,
    width: 532,
    height: 114.03,
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 262,
    width: 532,
    height: 114,
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 262,
    x2: 620,
    y2: 262,
    fill: "none",
    stroke: "#c4c4c4",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 376,
    width: 20,
    height: 6,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 376,
    width: 20,
    height: 6,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 376,
    width: 20,
    height: 6,
    fill: "#c4c4c4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M678,480H54V98h624v382ZM662,114H70v350h592V114Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,478H56V100h620v378ZM664,112H68v353.97h596V112Z",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664,
    y: 64,
    width: 12,
    height: 36,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 64,
    width: 12,
    height: 36,
    fill: "#c3c3c3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 198,
    width: 532,
    height: 12,
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "326 410 326 422 218.01 422 218 410 326 410",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 419,
    width: 108,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 415,
    width: 108,
    height: 2,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326 412 326 412.99 218 413 218.01 412.01 326 412",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "662 336 650 324 650 64.03 662 64 662 336",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 64,
    width: 1,
    height: 262.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655,
    y: 64,
    width: 2,
    height: 267,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660 334 659.01 334 659 64 659.99 64.03 660 334",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "646 210 634 198 634 64.04 646 64.01 646 210",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 64.01,
    width: 1,
    height: 136.97,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 64.01,
    width: 2,
    height: 140.99,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644 208 643.01 208 643 64.01 643.99 64.04 644 208",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "650 324 662 336 620 336 88 336 2 336 14 324 88 324 345.98 326.01 620 324 650 324",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 324,
    width: 532,
    height: 12,
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 327,
    width: 532,
    height: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 333,
    width: 656,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 329,
    width: 650,
    height: 2,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 326.01,
    width: 642,
    height: 0.99,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "620 198 634 198 646 210 620 210 620 198",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88 210 18 210 30 198 88 198 88 210",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 198,
    width: 532,
    height: 12,
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 201,
    width: 532,
    height: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 207,
    width: 624,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 203,
    width: 618,
    height: 2,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 200.01,
    width: 610,
    height: 0.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2 336.02 14 324.02 14 64.04 2 64.01 2 336.02",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 64.01,
    width: 1,
    height: 262.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 64,
    width: 2,
    height: 267,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4 334 4.99 334 5 64 4.01 64.03 4 334",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "18 210.02 30 198.02 30 64.02 18 63.99 18 210.02",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 64,
    width: 1,
    height: 137.01,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 64,
    width: 2,
    height: 141.02,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 64,
    width: 0.99,
    height: 144.02,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "354 324 354 326 351 329 349 329 346 326 346 324 346 210.01 346 208.01 349 205 351 205 354 208 354 210 354 324",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 207,
    width: 1,
    height: 120,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 203,
    width: 2,
    height: 128,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354 327 353.01 327 353 207 353.99 207.03 354 327",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "324 336 324 334.01 321 331.01 319 331.01 316.01 334 316 336 316 376 314 376 314 409.99 326 422 326 376 324 376 324 336",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 333,
    width: 1,
    height: 80,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 329,
    width: 2,
    height: 88,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324 333 323.01 333 323 420 323.99 419.97 324 333",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "220 334 221.01 333.01 223 331 225 331 227 333.02 228 334 228 376.01 230 376.01 230 409.99 218 422 218 376.01 220 376.01 220 334",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218 376.01 218 334 221.01 334 223 331 225 331 227 334 230 334 230 376.01 218 376.01",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221 376.01 221 334 221.01 333.01 223 331 225 331 227 333.02 227 334 227 376.01 221 376.01",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 333,
    width: 1,
    height: 80,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 329,
    width: 2,
    height: 88,
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220 333 220.99 333 221 420 220.01 419.97 220 333",
    fill: "#787878"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248,383.5c-5.79,0-10.5-4.71-10.5-10.5s4.71-10.5,10.5-10.5,10.5,4.71,10.5,10.5-4.71,10.5-10.5,10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,363c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M248,362c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.44,369.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.87l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.87h-.98v-5.69h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 261.9,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,251.9c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M307,250.9c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.44,258.56l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.87l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.87h-.98v-5.69h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 330,
    r: 14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,317c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M406,316c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 408.28,
    y: 311.31,
    width: 1,
    height: 22.28,
    transform: "translate(-34.19 596.03) rotate(-69.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.75,
    y: 337.36,
    width: 21.85,
    height: 1,
    transform: "translate(-85.87 146.57) rotate(-18.43)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 232,
    width: 32,
    height: 60,
    transform: "translate(612 -88) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,247v30h-58v-30h58M380,246h-60v32h60v-32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 366.7,
    y: 244.35,
    width: 1,
    height: 35.38,
    transform: "translate(-80.46 206.34) rotate(-28.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.16,
    cy: 262,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.22,
    y: 261.56,
    width: 35.22,
    height: 1,
    transform: "translate(-56.19 429.73) rotate(-61.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.83,
    cy: 262,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.5,
    y: 300.5,
    width: 31,
    height: 59,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,301v58h-30v-58h30M264,300h-32v60h32v-60h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.52,
    y: 329.65,
    width: 1,
    height: 35.07,
    transform: "translate(-175.43 399.52) rotate(-61.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 347.17,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 312.33,
    width: 35.32,
    height: 1,
    transform: "translate(-119.12 156.07) rotate(-28.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 312.83,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 300,
    width: 32,
    height: 60,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,301v58h-30v-58h30M124,300h-32v60h32v-60h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.58,
    y: 329.29,
    width: 1,
    height: 35.84,
    transform: "translate(-248.69 276.86) rotate(-61.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 347.17,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.13,
    y: 312.3,
    width: 35.88,
    height: 1,
    transform: "translate(-136.03 89.33) rotate(-28.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 312.83,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.5,
    y: 386.5,
    width: 31,
    height: 59,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,387v58h-30v-58h30M264,386h-32v60h32v-60h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.52,
    y: 415.44,
    width: 1,
    height: 35.46,
    transform: "translate(-251 444.77) rotate(-61.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 433.17,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 230.32,
    y: 398.38,
    width: 35.22,
    height: 1,
    transform: "translate(-160.15 166.41) rotate(-28.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 398.83,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 190,
    width: 26,
    height: 154.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,191v152.02h-24v-152.02h24M294,190h-26v154.02h26v-154.02h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 205.9,
    y: 263.66,
    width: 149.81,
    height: 1,
    transform: "translate(-25.85 497.82) rotate(-80.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.75,
    y: 269.36,
    width: 149.03,
    height: 1,
    transform: "translate(-31.08 503.03) rotate(-80.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.53,
    y: 190.6,
    width: 1,
    height: 152.82,
    transform: "translate(-39.87 49.54) rotate(-9.41)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 174.01,
    width: 32,
    height: 60,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,175.01v58h-30v-58h30M124,174.01h-32v60h32v-60h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 203.17,
    width: 1,
    height: 36.03,
    transform: "translate(-137.92 210.8) rotate(-61.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 221.18,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.99,
    y: 186.35,
    width: 36.03,
    height: 1,
    transform: "translate(-76 74.07) rotate(-28.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 186.85,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "623.5 323.12 634.97 330 623.5 336.88 623.5 323.12",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624,324l10,6-10,6v-12M623,322.23v15.53l1.51-.91,10-6,1.43-.86-1.43-.86-10-6-1.51-.91h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "621.03 204 632.5 197.12 632.5 210.88 621.03 204",
    fill: "#fbd961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,198v12l-10-6,10-6M633,196.23l-1.51.91-10,6-1.43.86,1.43.86,10,6,1.51.91v-15.53h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "343.12 221.5 356.88 221.5 350 232.97 343.12 221.5",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,222l-6,10-6-10h12M357.77,221h-15.53l.91,1.51,6,10,.86,1.43.86-1.43,6-10,.91-1.51h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "73.5 323.12 84.97 330 73.5 336.88 73.5 323.12",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,324l10,6-10,6v-12M73,322.23v15.53l1.51-.91,10-6,1.43-.86-1.43-.86-10-6-1.51-.91h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1.12 63.5 14.88 63.5 8 74.97 1.12 63.5",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,64l-6,10-6-10h12M15.77,63H.23l.91,1.51,6,10,.86,1.43.86-1.43,6-10,.91-1.51h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "73.03 204 84.5 197.12 84.5 210.88 73.03 204",
    fill: "#3b0500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,198v12l-10-6,10-6M85,196.23l-1.51.91-10,6-1.43.86,1.43.86,10,6,1.51.91v-15.53h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.12 74.5 24 63.03 30.88 74.5 17.12 74.5",
    fill: "#3b0500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,64l6,10h-12l6-10M24,62.06l-.86,1.43-6,10-.91,1.51h15.53l-.91-1.51-6-10-.86-1.43h0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 362.09,
    x2: 248,
    y2: 359.9,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.86,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 260.9,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 386,
    x2: 248,
    y2: 384,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.86,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 204,
    r: 14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,191c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M224,190c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 210.07,
    y: 195.95,
    width: 22.28,
    height: 1,
    transform: "translate(-53.91 87.67) rotate(-20.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.82,
    y: 200.93,
    width: 1,
    height: 21.85,
    transform: "translate(-49.65 354.82) rotate(-71.57)"
  })))));
};
export default SvgDAhuGeneralRoom;